import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ ]
  static values = {}
  
  connect() {
    addEventListener("turbo:submit-start", (event) => {
      const submitter = event.detail.formSubmission.submitter
      submitter.setAttribute('aria-busy', true)
    })

    addEventListener("turbo:submit-end", (event) => {
      const submitter = event.detail.formSubmission.submitter
      submitter.removeAttribute('aria-busy')
    })
  }
}
